var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nodata"},[(_vm.loading)?_c('div',{staticClass:"loading"}):[_c('div',{staticClass:"empty",style:(_vm.iconBgStyle)}),_c('div',{staticClass:"empty-text"},[_vm._v(_vm._s(_vm.text))])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }